import script from "./SAM2Sidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./SAM2Sidebar.vue?vue&type=script&setup=true&lang=js"

import "./SAM2Sidebar.vue?vue&type=style&index=0&id=470dbe7b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-470dbe7b"]])

export default __exports__